module.exports = __webpack_public_path__ + "img/PCT05.31e4fac7.svg";